export default {"src":"/_next/static/media/vertical_bars.c17702d5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};